export default {
  name: "DsfFormControlBox",
  functional: true,
  inject: {
    $vm: {
      default: null
    }
  },
  props: {
    owner: {
      type: Object,
      default() {
        return null
      }
    },
    blockClass: {
      type: [Object, Array],
      default() {
        return {}
      }
    },
    blockStyle: {
      type: Object,
      default() {
        return {}
      }
    },
    labelClass: {
      type: [Object, Array],
      default() {
        return {}
      }
    },
    labelStyle: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  render(h, _vm) {
    let owner = _vm.props.owner;
    _vm.data.staticClass = ['ds-control', 'ds-form-item', _vm.data.staticClass].join(" ")
    let clzss = [];
    clzss.push(...getClassArray(owner.getCss))
    clzss.push(...getClassArray(_vm.data.class));
    return h("div", {
      ..._vm.data,
      class: clzss
    }, isSimple(_vm) ? renderSimple(h, _vm) : renderContent(h, _vm))
  }
}

function renderSimple(h, _vm) {
  if (_vm.scopedSlots.simple && _vm.props.owner.inClient) {
    return _vm.scopedSlots.simple()
  }
}
function renderLabel(h, _vm) {
  // if (_vm.scopedSlots.label && _vm.props.owner.inClient) {
  //   return _vm.scopedSlots.label()
  // }
  if (_vm.props.owner.showLabel) {
    let owner = _vm.props.owner;
    return (
      <DsfFieldLabel
        mode={owner.showDataCaptionMode}
        style={{ width: dsf.unitSize(owner.$labelWidth), ...(_vm.props.labelStyle || {}) }}
        showIcon={owner.showDataCaptionIcon}
        trigger={owner.showDataCaptionTrigger}
        dataCaption={owner.dataCapion}
        isDesign={owner.isDesign}
        owner={owner}>
        {owner.$t(owner.label||"")}
      </DsfFieldLabel>
    )
  }
  return h();
}
function renderContent(h, _vm) {
  if (!_vm.props.owner.inClient) {
    return h();
  }
  let owner = _vm.props.owner
  let clzss = ['ds-form-block', ...getClassArray(_vm.props.blockClass)];
  let showLabel = _vm.props.owner.showLabel;
  let click = _vm?.data?.on?.['block-click'];
  let blockOn = {};
  if (click) {
    blockOn['click'] = click;
  }
  return [
    showLabel ? renderLabel(h, _vm) : h(),
    h('div', {
      class: clzss,
      on: blockOn,
      style: {
        'margin-left': showLabel ? dsf.unitSize(owner.$labelWidth) : "0px",
        ...(_vm.props.blockStyle || {})
      }
    }, [_vm.scopedSlots.content ? _vm.scopedSlots.content() : h()])
  ]
}

function isSimple(vm) {
  let owner = vm.props.owner;
  return owner.simple && owner.readOnly && owner.isDesign
}

function getClassArray(clzss) {
  let arr = [];
  if (clzss) {
    if (dsf.isArray(clzss)) {
      arr.push(clzss);
    }
    else if (dsf.isObject(clzss)) {
      for (let k in clzss) {
        clzss[k] && arr.push(k);
      }
    }
  }
  return arr;
}